import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { Category } from '@sb-tools/typescript/models/category.model';
import { ReplaySubjectCount } from './common-data-for-settings.service';

@Injectable({
    providedIn: 'root',
})
export class CategoriesService {
    categoriesList: BehaviorSubject<Category[]> = new BehaviorSubject<Category[]>([]);
    categoriesList$: Observable<Category[]> = this.categoriesList.asObservable();
    categoryEditingCanceledSubject = new Subject<void>();
    changeCategory$: ReplaySubject<Category> = new ReplaySubject<Category>(ReplaySubjectCount);
    currentCategory: BehaviorSubject<Category> = new BehaviorSubject<Category>(null);
    currentCategory$: Observable<Category> = this.currentCategory.asObservable();
}
